import { Component, forwardRef, input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { BuildingSectionDetailDto } from '@artemis-software/wr-api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-building-section-select-form-control',
  templateUrl: './building-section-select-form-control.component.html',
  styleUrl: './building-section-select-form-control.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingSectionSelectFormControlComponent),
      multi: true,
    },
  ],
})
export class BuildingSectionSelectFormControlComponent extends AbstractFormControl<string>{
  buildingSections = input.required<BuildingSectionDetailDto[] | undefined>();
}
